/*
 * @Author: your name
 * @Date: 2021-12-09 14:29:40
 * @LastEditTime: 2021-12-21 09:58:54
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \鲁南\src\modules\reserve\const\noticeTableOption.js
 */
import utils from '@src/common/utils'
import i18n from '@src/common/lib/i18n'
const tableOption = function () {
    return {
        page: true,
        selection: false,
        index: true,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'left',
        size: 'small',
        maxHeight: '400px',
        labelWidth: '100px',
        menuAlign: 'center',
        emptyText: '暂无数据',
        column: [
            {
                label: '阅读状态',
                align: 'center',
                prop: 'notifyStatus',
                formatter: (row, value) => {
                    if (Number(value) === 0) {
                        return '未读'
                    } else if (Number(value) === 2) {
                        return '已读'
                    } else {
                        return "发送中"
                    }
                },
                columnWidth: 100
            },
            {
                label: '阅读时间',
                align: 'left',
                prop: 'lastNotifyTime',
                columnWidth: 150,
                formatter: (row, value) => {
                    if (row.notifyStatus == 2) {
                        return row.lastNotifyTime
                    } else {
                        return ''
                    }
                },
            },
            {
                label: '姓名',
                align: 'center',
                prop: 'name',
            },

            {
                label: '工号',
                align: 'center',
                prop: 'toUser',
                hide: true

            },
            {
                label: '手机号',
                prop: 'phone',
                align: 'center',

            },
            {
                label: '所属应急组',
                align: 'center',
                prop: 'groupName',
            },
            {
                label: '岗位',
                align: 'center',
                prop: 'position',
                hide: true
            },


        ]
    }
}
export default tableOption